<template>
  <div class="agent-chat-container">
    <v-card class="d-flex flex-column agent-chat-card">
      <!-- Header fijo, compacto -->
      <v-card-title class="flex-shrink-0 py-2">
        <span class="subtitle-1 font-weight-medium">Agent Chat Test</span>
      </v-card-title>

      <!-- Agent Selection - fijo, compacto -->
      <div class="flex-shrink-0 px-4 pb-2">
        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model="agentUuid"
              label="Agent UUID"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="conversationUuid"
              label="Conversation UUID"
              outlined
              dense
              readonly
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <!-- Chat Messages - área scrolleable -->
      <div class="chat-messages-container flex-grow-1 px-4">
        <v-card outlined class="chat-messages-card">
          <v-card-text ref="messagesContainer">
            <div v-if="messages.length === 0" class="text-center grey--text">
              No messages yet. Start chatting!
            </div>
            <div v-for="(msg, idx) in messages" :key="idx" class="mb-3">
              <div :class="msg.role === 'user' ? 'text-right' : 'text-left'">
                <v-chip
                  :color="msg.role === 'user' ? 'primary' : 'secondary'"
                  dark
                  label
                >
                  {{ msg.role }}
                </v-chip>
                <div class="mt-1">
                  <v-card
                    :color="msg.role === 'user' ? 'blue lighten-5' : 'grey lighten-4'"
                    class="d-inline-block pa-3"
                    style="max-width: 80%;"
                  >
                    <pre v-if="msg.type === 'tool_use'" style="white-space: pre-wrap;">{{ JSON.stringify(msg.content, null, 2) }}</pre>
                    <div v-else>{{ msg.content }}</div>
                  </v-card>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- Input Area - fijo abajo, compacto -->
      <div class="flex-shrink-0 px-4 pt-2 pb-2">
        <v-row dense align="center">
          <v-col>
            <v-textarea
              v-model="userMessage"
              label="Your message (Ctrl+Enter to send)"
              outlined
              rows="2"
              dense
              hide-details
              :disabled="loading"
              @keydown.enter.ctrl="sendMessage"
            ></v-textarea>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="!agentUuid || !userMessage"
              @click="sendMessage"
              class="mr-2"
            >
              Send
            </v-btn>
            <v-btn
              color="secondary"
              @click="clearChat"
            >
              Clear
            </v-btn>
          </v-col>
        </v-row>

        <!-- Debug Info colapsado -->
        <v-expansion-panels flat class="mt-2">
          <v-expansion-panel>
            <v-expansion-panel-header class="pa-0">
              <small class="grey--text">Debug Info</small>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <pre style="white-space: pre-wrap; font-size: 11px; max-height: 150px; overflow-y: auto;">{{ debugInfo }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </div>
</template>

<script>
import { async_command_dispatcher } from '@/api/client'

export default {
  name: 'AgentChat',
  data() {
    return {
      agentUuid: '',
      conversationUuid: null,
      userMessage: '',
      messages: [],
      loading: false,
      debugInfo: null,
      command_dispatcher: async_command_dispatcher
    }
  },
  methods: {
    async sendMessage() {
      if (!this.agentUuid || !this.userMessage) return

      this.loading = true
      const messageToSend = this.userMessage

      // Add user message to display
      this.messages.push({
        role: 'user',
        type: 'text',
        content: messageToSend
      })

      this.userMessage = ''

      try {
        const response = await this.command_dispatcher.dispatch_with_result('chat.with.agent', {
          agent_uuid: this.agentUuid,
          conversation_uuid: this.conversationUuid,
          user_message: messageToSend,
          company_id: parseInt(this.$route.params.companydb_id),
          user_id: this.$store.state.me.id
        })

        this.debugInfo = response

        // Update conversation UUID
        if (response.conversation_uuid) {
          this.conversationUuid = response.conversation_uuid
        }

        // Add assistant message
        if (response.message) {
          this.messages.push({
            role: 'assistant',
            type: 'text',
            content: response.message
          })
        }

        // Add full messages if available
        if (response.messages) {
          this.messages = response.messages.filter(m =>
            m.type === 'text' || m.type === 'tool_use'
          )
        }

      } catch (error) {
        console.error('Error sending message:', error)
        const errorMsg = error && error.message ? error.message : 'Unknown error'
        this.messages.push({
          role: 'system',
          type: 'text',
          content: 'Error: ' + errorMsg
        })
        this.debugInfo = error
      } finally {
        this.loading = false
      }
    },
    clearChat() {
      this.messages = []
      this.conversationUuid = null
      this.userMessage = ''
      this.debugInfo = null
    }
  }
}
</script>

<style scoped>
.agent-chat-container {
  height: calc(100vh - 64px); /* Resta la altura del toolbar/navbar */
  padding: 8px;
  box-sizing: border-box;
}

.agent-chat-card {
  height: 100%;
  overflow: hidden;
}

.chat-messages-container {
  min-height: 0; /* Importante para que flex-grow funcione con overflow */
  overflow: hidden;
}

.chat-messages-card {
  height: 100%;
  overflow-y: auto;
}

.code-editor {
  font-family: monospace;
}
</style>
